/**
 * Encart « Lecture » en tête de chaque analyse.
 *
 * Reprend la structure du rapport PDF : le verdict d'abord, la méthode
 * ensuite, les graphiques après. Un graphique causal sans phrase de lecture se
 * fait interpréter de travers — et les cinq analyses de ce lot mesurent toutes
 * des associations, jamais des effets.
 */

import type { ReactNode } from 'react';

interface Props {
  /** Le verdict, en une ou deux phrases. */
  children: ReactNode;
  /** Comment c'est calculé, et ce que ça ne dit pas. */
  method: ReactNode;
}

export function ReadingBox({ children, method }: Props) {
  return (
    <section className="reading">
      <p className="reading__label">Lecture</p>
      <p className="reading__text">{children}</p>
      <p className="reading__method">{method}</p>
    </section>
  );
}
